import { APP_FAVORITES_MIGRATED, APP_FAVORITES_OWNER, APP_LIVE_FAVORITES, APP_PREMATCH_FAVORITES } from '@common/constants';
import { useAppDispatch, useAppSelector } from '@common/hooks/store';
import { getUserId, userLoggedIn } from '@features/auth/slice/authSlice';
import { useImportFavoriteEventsMutation, useLazyGetFavoriteIdsQuery } from '@features/favorites/api/favoritesApi';
import { favoriteIds } from '@features/favorites/favoriteIds';
import { syncLiveFavorites } from '@features/live/slice/liveSlice';
import { useEffect } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

export default function useFavoritesSync() {
  const dispatch = useAppDispatch();
  const loggedIn = useAppSelector(userLoggedIn);
  const userId = useAppSelector(getUserId);
  const [ fetchIds ] = useLazyGetFavoriteIdsQuery();
  const [ importEvents ] = useImportFavoriteEventsMutation();

  useEffect(() => {
    if (!loggedIn || !userId) {
      return;
    }
    let cancelled = false;
    const migratedKey = `${APP_FAVORITES_MIGRATED}_${userId}`;

    const run = async () => {
      if (!reactLocalStorage.get(migratedKey)) {
        const owner = Number(reactLocalStorage.get(APP_FAVORITES_OWNER, 0));
        if (!owner) {
          const local = favoriteIds([
            ...favoriteIds(reactLocalStorage.getObject(APP_LIVE_FAVORITES, [])),
            ...favoriteIds(reactLocalStorage.getObject(APP_PREMATCH_FAVORITES, [])),
          ]);
          if (local.length) {
            await importEvents(local).unwrap();
          }
        }
        reactLocalStorage.set(migratedKey, 1);
      }
      const ids = await fetchIds(undefined, false).unwrap();
      if (cancelled) {
        return;
      }
      const events = favoriteIds(ids?.events);
      reactLocalStorage.setObject(APP_LIVE_FAVORITES, events);
      reactLocalStorage.setObject(APP_PREMATCH_FAVORITES, events);
      reactLocalStorage.set(APP_FAVORITES_OWNER, userId);
      dispatch(syncLiveFavorites(events));
    };

    run().catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, [ dispatch, fetchIds, importEvents, loggedIn, userId ]);
}
